import { FieldValues, UseFormSetValue } from 'react-hook-form';

import {
	formatCity,
	formatEmail,
	formatInitials,
	formatPostalCode,
	formatSurname,
	formatSurnamePrefix,
	formatTelephone,
} from '@anwb/poncho/utilities/formatters';
import { PLCustomerData } from 'types';

export const formatFormValues = (
	setValue: UseFormSetValue<FieldValues>,
	formValues: Partial<PLCustomerData>
) => {
	const { initials, lastNamePrefix, lastName, postalCode, city, email, phoneNumber } = formValues;
	setValue('initials', formatInitials(initials));
	setValue('lastNamePrefix', formatSurnamePrefix(lastNamePrefix));
	setValue('lastName', formatSurname(lastName));
	setValue('postalCode', formatPostalCode(postalCode));
	setValue('city', formatCity(city));
	setValue('email', formatEmail(email));
	setValue('phoneNumber', formatTelephone(phoneNumber));
};
